import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import plugins from './plugins';

import auth from '@/core/shared/auth/store';
import organization from '@/core/shared/vuex-modules/organization';
import country from '@/core/shared/vuex-modules/country';
import region from '@/core/shared/vuex-modules/region';
import webPanel from '@/core/shared/web-panel/store';
import net from '@/core/shared/net';
import bundles from '@/bundle/store';
import contentOwnerships from '@/content-ownership/store';
import admin from '@/admin/store';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  state: {},
  actions,
  plugins,
  modules: {
    auth,
    organization,
    country,
    region,
    webPanel,
    net,
    bundles,
    contentOwnerships,
    admin,
  },
});

if (module.hot) {
  module.hot.accept(['./actions'], () => {
    store.hotUpdate({
      actions: require('./actions'),
      modules: {
        auth: require('@/core/shared/auth/store'),
        organization: require('@/core/shared/vuex-modules/organization'),
        country: require('@/core/shared/vuex-modules/country'),
        region: require('@/core/shared/vuex-modules/region'),
        webPanel: require('@/core/shared/web-panel/store'),
        net: require('@/core/shared/net'),
        bundles: require('@/bundle/store'),
        contentOwnerships: require('@/content-ownership/store'),
        admin: require('@/admin/store'),
      },
    });
  });
}

export default store;
